import { render } from "./tg-bot-menu-settings.component.vue?vue&type=template&id=5aedab4b"
import script from "./tg-bot-menu-settings.component.vue?vue&type=script&lang=js"
export * from "./tg-bot-menu-settings.component.vue?vue&type=script&lang=js"

import "./tg-bot-menu-settings.component.vue?vue&type=style&index=0&id=5aedab4b&lang=css"

import exportComponent from "/mnt/ssd2/projects/techno2_remaster/client_ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__